module.exports = __webpack_public_path__ + "static/media/logo.574dd35b.svg";